"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _HorizontalLegend = require("./legends/HorizontalLegend");
var _VerticalLegend = _interopRequireDefault(require("./legends/VerticalLegend"));
var _ChartTooltip = _interopRequireDefault(require("./ChartTooltip"));
var _chartOperations = require("../utils/chart-operations");
var _reactIntersectionObserver = require("react-intersection-observer");
var _SvgChart = require("./SvgChart.styled");
var _ChartDescription = _interopRequireDefault(require("./ChartDescription"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function SvgChart(props) {
  var _props$boxRef, _boxRef$current, _boxRef$current2, _boxRef$current3;
  const {
    margin,
    svgRef,
    tooltipRef,
    children,
    chart,
    palette,
    keepAggregate = true,
    seriesLabels,
    onVisible,
    filterComponent
  } = props;
  const ratio = (0, _chartOperations.ratioToNumber)(chart.aspectRatio);
  const maxWidth = chart.spanRow ? 1024 : 800;
  const boxRef = (_props$boxRef = props.boxRef) !== null && _props$boxRef !== void 0 ? _props$boxRef : _react.default.useRef(null);
  const [svgWidth, setSvgWidth] = (0, _react.useState)((_boxRef$current = boxRef.current) === null || _boxRef$current === void 0 ? void 0 : _boxRef$current.offsetWidth);
  const [svgHeight, setSvgHeight] = (0, _react.useState)(((_boxRef$current2 = boxRef.current) === null || _boxRef$current2 === void 0 ? void 0 : _boxRef$current2.offsetWidth) / ratio);
  const {
    ref: viewRef,
    inView
  } = (0, _reactIntersectionObserver.useInView)({
    threshold: 0.1,
    triggerOnce: true
  });
  (0, _react.useLayoutEffect)(() => {
    if (boxRef.current === null) {
      return;
    }
    const width = Math.min(boxRef.current.offsetWidth, maxWidth) - (chart.legend === "vertical" ? 140 : 0);
    const height = width / ratio;
    setSvgWidth(width);
    setSvgHeight(height);
  }, [maxWidth, chart.aspectRatio, chart.legend, (_boxRef$current3 = boxRef.current) === null || _boxRef$current3 === void 0 ? void 0 : _boxRef$current3.offsetWidth]);
  (0, _react.useLayoutEffect)(() => {
    if (!svgRef.current || !inView || !onVisible) {
      return;
    }
    onVisible();
  }, [inView, svgRef.current]);
  const series = seriesLabels || _chartOperations.ChartOps.getSeriesLabels(chart, keepAggregate);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: viewRef
  }, /*#__PURE__*/_react.default.createElement(_SvgChart.ChartBox, {
    ref: boxRef
  }, filterComponent, /*#__PURE__*/_react.default.createElement(_SvgChart.ChartSvg, {
    ref: svgRef,
    viewBox: svgWidth && svgHeight ? "0 0 ".concat(svgWidth, " ").concat(svgHeight) : undefined,
    spanRow: chart.spanRow,
    aspectRatio: ratio,
    verticalLegend: chart.legend === "vertical"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(".concat(margin.left, ", ").concat(margin.top, ")"),
    className: "main-group ".concat(chart.labelSize, "-label")
  }, svgWidth && svgHeight && children)), svgWidth && svgHeight && chart.legend === "horizontal" && /*#__PURE__*/_react.default.createElement(_HorizontalLegend.HorizontalLegend, {
    labels: series,
    palette: palette,
    format: chart.seriesFormat
  }), svgWidth && svgHeight && chart.legend === "vertical" && /*#__PURE__*/_react.default.createElement(_VerticalLegend.default, {
    labels: series,
    palette: palette,
    format: chart.seriesFormat
  }), tooltipRef && /*#__PURE__*/_react.default.createElement(_ChartTooltip.default, {
    tooltipRef: tooltipRef
  })), /*#__PURE__*/_react.default.createElement(_ChartDescription.default, {
    description: chart.description
  }));
}
var _default = SvgChart;
exports.default = _default;